import MirrorFind from './MirrorFind';
export default MirrorFind;
